'use strict';

var Fastclick = require('fastclick');
module.exports = function injectTapEventPlugin() {
	var supportTouch = ('ontouchstart' in document);
	if (supportTouch) {
		Fastclick.attach(document.body);
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-lite/lib/react-tap-event-plugin.js
 ** module id = 1674
 ** module chunks = 0
 **/